<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-card class="card--flex-toolbar">
        <v-toolbar flat>
          <v-toolbar-title class="grey--text">Productos</v-toolbar-title>
          <v-spacer />
          <v-dialog v-model="dialog" max-width="1200px" persistent>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on"> Nuevo </v-btn>
            </template>
            <FormProducto
              v-if="dialog"
              :id-item="itemSelectId"
              @close="dialog = false"
              @save="saveItem"
            />
          </v-dialog>
        </v-toolbar>
        <v-container grid-list-md style="max-width: initial; padding: 20px">
          <v-row>
            <v-flex xs6 d-flex>
              <SearchFamiliasInput
                @selected="filter.familia_id = $event"
              ></SearchFamiliasInput>
            </v-flex>
            <v-flex xs6 d-flex>
              <SearchProductosInput
                @selected="filter.producto_id = $event"
              ></SearchProductosInput>
            </v-flex>
            <v-flex xs6 d-flex>
              <SearchSubFamiliasInput
                @selected="filter.subfamilia_id = $event"
              ></SearchSubFamiliasInput>
            </v-flex>

            <v-flex xs6 d-flex>
              <v-select
                v-model="filter.activo"
                :items="[
                  { id: 1, nombre: 'Activo' },
                  { id: 0, nombre: 'Inactivo' },
                ]"
                item-text="nombre"
                item-value="id"
                label="Activo"
                prepend-icon="mdi-check-circle"
              />
            </v-flex>
          </v-row>

          <!-- <v-layout wrap>
                        <v-form>
                            <v-layout wrap>
                                <v-col
                                    xs12
                                    sm6
                                >
                                    <v-select
                                        v-model="filter.familia_id"
                                        :items="familias"
                                        item-text="nombre"
                                        item-value="id"
                                        :loading="loading_familia"
                                        label="Familias"
                                    />

                                </v-col>
                            </v-layout>
                        </v-form>
                    </v-layout> -->
        </v-container>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            class="white--text"
            :loading="loading"
            :disabled="loading"
            @click="listar"
          >
            Buscar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-flex grow pt-2>
      <v-data-table
        :headers="headers"
        :items="productos"
        :options.sync="options"
        class="elevation-1"
        :footer-props="{
          itemsPerPageOptions: $root.OPTIONS_PER_PAGE_DATATABLE,
        }"
        :server-items-length="productosTotal"
        :loading="loading"
        @update:options="listar"
      >
        <template v-slot:item.imagen_url="{ item }">
          <v-avatar tile class="ma-2">
            <v-img :lazy-src="$root.IMAGE_LAZY" :src="item.imagen_url"></v-img>
          </v-avatar>
        </template>
        <template v-slot:item.activo="{ item }">
          <v-chip dark :class="{ teal: item.activo, gray: !item.activo }">
            {{ item.activo ? "Activo" : "Inactivo" }}
          </v-chip>
        </template>
        <template v-slot:item.familia="{ item }">
          {{ item.familia.nombre }}
        </template>
        <template v-slot:item.subfamilia="{ item }">
          <v-chip
            dark
            :class="{
              teal:
                0 == item.familia.subfamilias_count
                  ? item.subfamilia
                    ? false
                    : true
                  : true,
              orange:
                0 != item.familia.subfamilias_count
                  ? null == item.subfamilia
                    ? true
                    : false
                  : false,
            }"
          >
            {{
              item.familia.subfamilias_count == 0
                ? "No Aplica"
                : item.subfamilia
                ? item.subfamilia.nombre
                : "Asignar sub-categoría"
            }}
          </v-chip>
        </template>
        <template v-slot:item.familia.subfamilias_count="{ item }">
          <ChipProductVisibility :product="item"></ChipProductVisibility>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="mr-2"
                v-on="on"
                color="light-blue darken-4"
                @click="editItemId(item.id)"
              >
                <v-icon small color="light-blue darken-4"> edit </v-icon>
              </v-btn>
            </template>
            <span>Editar producto</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                class="mr-2"
                v-on="on"
                color="light-green darken-4"
                @click="setModificadorItemId(item)"
              >
                <v-icon small color="light-green darken-4">
                  mdi-list-status
                </v-icon>
              </v-btn>
            </template>
            <span>Administrar modificadores</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                v-on="on"
                color="red"
                @click="deleteItemConfirm(item)"
              >
                <v-icon small color="red"> delete </v-icon>
              </v-btn>
            </template>
            <span>Eliminar producto</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-flex>
    <v-dialog v-model="dialog_modificadores" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Administrar modificadores</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md style="max-width: initial; padding: 20px">
            <v-row>
              <v-flex xs12 d-flex>
                <SearchModificadores
                  :selected="item.modificadores"
                  @selected="modificadoresSeleccionados = $event"
                ></SearchModificadores>
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="gray darken-1" @click="dialog_modificadores = false">
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            class="white--text"
            :loading="loading_modificadores"
            :disabled="loading_modificadores"
            @click="relacionarModificadores"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Eliminar registro</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn color="gray darken-1" @click="dialog_delete = false">
            No
          </v-btn>
          <v-btn
            color="red darken-1"
            class="white--text"
            :loading="loading_delete"
            :disabled="loading_delete"
            @click="deleteItem"
          >
            Si
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from "axios";
import FormProducto from "@components/FormProductos";
import EventBus from "@/EventBus";
import SearchProductosInput from "@components/SearchProductosInput";
import SearchFamiliasInput from "@components/SearchFamiliasInput";
import SearchSubFamiliasInput from "@components/SearchSubfamiliasInput";
import ChipProductVisibility from "@components/ChipProductVisibility";
import SearchModificadores from "@components/SearchModificadores";

export default {
  name: "ProductosPage",
  components: {
    FormProducto,
    SearchProductosInput,
    SearchFamiliasInput,
    SearchSubFamiliasInput,
    ChipProductVisibility,
    SearchModificadores,
  },
  data() {
    return {
      dialog: false,
      dialog_delete: false,
      dialog_modificadores: false,
      loading_modificadores: false,
      item: {},
      modificadoresSeleccionados: [],
      headers: [
        {
          text: "#",
          align: "center",
          sortable: false,
          value: "imagen_url",
          width: "50px",
        },
        {
          text: "Nombre",
          align: "left",
          sortable: false,
          value: "nombre",
        },
        {
          text: "Orden",
          align: "center",
          sortable: true,
          value: "order",
        },
        {
          text: "Categoría",
          align: "left",
          sortable: false,
          value: "familia.nombre",
        },
        {
          text: "Sub-Categoría",
          align: "left",
          sortable: false,
          value: "subfamilia",
        },
        {
          text: "Visible en la App",
          align: "left",
          sortable: false,
          value: "familia.subfamilias_count",
        },
        {
          text: "Activo",
          align: "left",
          sortable: false,
          value: "activo",
        },
        { text: "Opciones", value: "actions", sortable: false },
      ],
      filter: {
        familia_id: null,
        subfamilia_id: null,
        producto_id: null,
        activo: null,
      },
      loading_familia: false,
      productos: [],
      productosTotal: 0,
      itemSelectId: 0,
      itemDelete: null,
      loading: false,
      loading_delete: false,
      options: {
        descending: true,
        page: 1,
        itemsPerPage: this.$root.OPTIONS_PER_PAGE_DATATABLE[0],
        totalItems: 0,
      },
      snackbar: false,
      snackbar_config: {
        color: "",
        multi_line: false,
        timeout: 6000,
        mobile: false,
        text_content: "",
      },
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },
  mounted() {
    this.listarFamilias();
  },
  methods: {
    setModificadorItemId(item) {
      this.item = item;
      this.itemSelectId = parseInt(item.id);
      this.dialog_modificadores = true;
    },
    initialize() {},
    close() {
      this.dialog = false;
      this.itemSelectId = 0;
    },
    editItemId(itemId) {
      this.itemSelectId = parseInt(itemId);
      this.dialog = true;
    },
    deleteItem() {
      this.loading_delete = true;
      axios
        .post("/api/productos/eliminar/" + this.itemDelete.id)
        .then((response) => {
          this.loading_delete = false;
          let { data } = response;
          if (data.success) {
            EventBus.$emit("tugarrafon:show-snackbar", {
              text_content: data.message,
              color: "success",
            });

            this.itemDelete = null;
            this.dialog_delete = false;
            this.listar();
          }
        })
        .catch((error) => {
          this.loading_delete = false;
          if (error.response && error.response.data) {
            EventBus.$emit("tugarrafon:show-snackbar", {
              text_content: error.response.data.message,
              color: "error",
            });
          } else {
            EventBus.$emit("tugarrafon:show-snackbar", {
              text_content: "Error durante la petición",
              color: "error",
            });
          }
        });
    },
    deleteItemConfirm(item) {
      this.itemDelete = item;
      this.dialog_delete = true;
    },
    listar() {
      this.loading = true;
      const { sortBy, sortDesc, descending, page, itemsPerPage } = this.options;
      axios
        .get("/api/productos/listar", {
          params: {
            sortBy: sortBy,
            sortDesc: sortDesc,
            descending: descending,
            page: page,
            rowsPerPage: itemsPerPage,
            search: this.search,
            ...this.filter,
          },
        })
        .then((success) => {
          this.loading = false;
          let { data } = success;
          this.productos = data.data;
          this.options.page = data.current_page;
          this.productosTotal = data.total;
        });
    },
    saveItem() {
      this.dialog = false;
      this.listar();
    },
    listarFamilias() {
      this.loading_familia = true;
      axios
        .get("/api/familia/listar", {
          params: {
            is_list: 1,
          },
        })
        .then((success) => {
          this.loading_familia = false;
          let { data } = success;
          this.familias = data;
          if (this.editar === false) {
            this.form.familia_id = this.familias[0].id;
          }
        })
        .catch(() => {
          this.loading_familia = false;
        });
    },
    relacionarModificadores(items) {
      this.loading_modificadores = true;
      axios
        .post("/api/productos/modificadores/guardar", {
          producto_id: this.itemSelectId,
          modificadores: this.modificadoresSeleccionados,
        })
        .then((success) => {
          this.loading_modificadores = false;
          this.dialog_modificadores = false;
          this.listar();
          /*  let { data } = success;
          this.familias = data; */
        })
        .catch(() => {
          this.loading_modificadores = false;
        });
    },
  },
};
</script>

<style scoped>
td img {
  width: 40px;
  height: 40px;
}
</style>
